export default __webpack_public_path__ + "static/media/logo-light.e73b11e8.png";